<template>
  <section>
    <el-container>
      <el-form label-width="120px" :model="UserForm" :rules="Rules" ref="User">
<!--        <el-form-item label="手机号" prop="phoneNum">-->
<!--          <el-input v-model="UserForm.phoneNum" placeholder="请输入手机号" length=11></el-input>-->
<!--        </el-form-item>-->

        <el-form-item label="密码" >
          <el-input type="password" v-model="UserForm.adminUserPwd" auto-complete="new-password"
                    placeholder="请输入新密码"></el-input>
        </el-form-item>

        <!--  按钮  -->
        <el-form-item>
          <el-button type="primary" @click="changePasswd()">修改密码</el-button>
        </el-form-item>
      </el-form>
    </el-container>
  </section>
</template>

<script>
import {Message} from "element-ui";

export default {
  name: "ForgetPasswd",
  data() {
    return {
      Rules: '',
      ID:'',
      UserForm: {
          id:"",
          adminUserPwd: '',
      }
    }
  },
  created() {
    this.getMenu()
  },
  methods: {
    // 获取菜单
    async getMenu() {
      this.ID = window.sessionStorage.getItem('ID')
        this.UserForm.id = this.ID;
    },
    // 修改密码
    changePasswd() {
      console.log(this.UserForm);
      if (!this.UserForm.adminUserPwd) {
        Message.error("请输入2-15密码！");
        return;
      } else if (this.UserForm.adminUserPwd.length >15 || this.UserForm.adminUserPwd.length < 2) {
        Message.error("请输入2-15密码！");
        return;
      } else {
        this.$http.post("/adminUpdate", this.UserForm).then(res => {

          if (res.data.code == 1) {
            Message.success("修改成功，快去登陆吧")
            window.sessionStorage.clear(); // 清除token
            this.$router.push("/admin");
          } else {
            Message.error(res.data.data)
          }
        });
      }
    }
  }
}
</script>

<style scoped>

</style>
